/* 
Example: 

{% liquid
  assign main_container = '.quick-add-subscription--' | append: product.id
  assign price_container = '#price-' | append: section.id | append: ' .price-item--regular'
  assign atc_button = '#product-form-' | append: section.id | append: ' .product-form__submit'
%}

<div class="quick-add-subscription--{{ product.id }}">
  {% render 'subscribe-switch', 
    id: product.id,
    main_container: main_container, ** Required
    price_container: price_container, ** Required
    atc_button: atc_button
  %}
</div>                                                

*/

if (!customElements.get('subscribe-switch-yotpo')) {
  class SubscribeSwitchYotpo extends HTMLElement {
    constructor() {
      super();
      this.id = this.dataset.prodId;
      this.switchToggle = this.toBoolean(this.dataset.switch);
      this.switchInput = this.querySelector('input');
      this.classList.add('disabled');
      const waitForWidget = setInterval(() => {
        if(window.yotpoWidgetsContainer) {
          clearInterval(waitForWidget);
          this.classList.remove('disabled');
          this.switchInput.addEventListener('change', this.onToggle.bind(this));
          if(this.toBoolean(this.dataset.force)) this.switchInput.click();

        }
      });
    }
  
    connectedCallback() {
      
    }
  
    onToggle(close = true) {
      this.switchToggle = !this.switchToggle;

      if(this.switchToggle && close) {
        const switches = document.querySelectorAll(`subscribe-switch-yotpo:not([data-prod-id="${this.id}"])`);
        switches.forEach((element) => {
          if(this.toBoolean(element.dataset.switch)) 
            element.querySelector('input').click();
        });
      } else {
        const oneTime = this.querySelector('[data-selling-plan-name="One-Time Purchase"]') 
        ?? this.querySelector('.yotpo-radio-buy-once-container [data-selling-plan-name]');
        setTimeout(() => oneTime.click(), 500);
      }

      this.dataset.switch = this.switchToggle;
    }
  
    

    toBoolean(value) {
      return value == 'true' ?? false;
    }
  }
  
  customElements.define('subscribe-switch-yotpo', SubscribeSwitchYotpo);
}
